//React component for the "StationsPage" page i.e. the big page that lists all of the news stations
import StationsPageTableBasic from './StationsPageTableBasic.js';
import { Grid2 } from '@mui/material';
import HeaderBar from '../Shared/HeaderBar/HeaderBar.js';
import NavigationBar from "../Shared/NavigationBar/NavigationBar.js"

export default function StationsPage(){


    return (
        <>
            <HeaderBar page={"StationsPage"} ></HeaderBar>
                <Grid2 container={true} justifyContent={'center'} alignItems={'center'} direction={'column'} paddingBottom={'100px'} id={"StationsPageBasicGrid"} >
                    <StationsPageTableBasic></StationsPageTableBasic>
                </Grid2>
            <NavigationBar></NavigationBar>
        </>
    )
}
